import { FC, useState, createContext, useContext, SetStateAction, Dispatch, useEffect } from 'react'
import { WithChildren } from '../../../../_metronic/helpers'
import { getItem, removeItem, setItem } from '../../../core/utils/localstorage'
import { tokenKey, estateKey } from '../../../core/services/SERVICE-CONSTANTS'
import { IUser } from '../../../core/interfaces'
import { apiCaller } from '../../../core/hooks/useApi'
import { ServiceAgent } from '../../../core/services/serviceAgent'
import http from '../../../core/services/HttpConfig'
import { useLoadingContext } from '../../../core/context/loading/loading'
import './authStyle.scss'
const userInfoLsKey = http.tokenKey

interface IinitAuthContextPropsState {
  jwtToken: string | undefined
  saveToken: (token: string | undefined) => void
  saveUserInfo: (info: IUser | undefined) => void
  setUserInfo: Dispatch<SetStateAction<IUser | undefined>>
  setLogInEstate: Dispatch<SetStateAction<string | undefined>>
  logInEstate: string | undefined
  logout: () => void
  userInfo: IUser | undefined,
  getUserProfile: () => void
  isAuthLoading: boolean
}
const initAuthContextPropsState = {
  jwtToken: '',
  saveToken: () => { },
  saveUserInfo: () => { },
  setUserInfo: () => { },
  logout: () => { },
  userInfo: undefined,
  setLogInEstate: () => { },
  logInEstate: '',
  getUserProfile: () => { },
  isAuthLoading: true,
}
const AuthContext = createContext<IinitAuthContextPropsState>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC<WithChildren> = ({ children }) => {
  const { handleClose, handleOpen } = useLoadingContext();
  const [jwtToken, setJwtToken] = useState<string | undefined>(getItem(tokenKey))
  const [logInEstate, setLogInEstate] = useState<string | undefined>(getItem(estateKey))
  const [userInfo, setUserInfo] = useState<IUser | undefined>()
  const [isAuthLoading, setIsAuthLoading] = useState<boolean>(!!getItem(tokenKey))

  const saveToken = (token: string | undefined) => {
    setJwtToken(token)
    if (token) {
      setItem(tokenKey, token)
    } else {
      removeItem(tokenKey)
      removeItem(userInfoLsKey)
    }
  }

  const saveUserInfo = (info: IUser | undefined) => {
    setUserInfo(info)
    setItem(userInfoLsKey, JSON.stringify(info))
  }

  const getUserProfile = () => {
    apiCaller({
      api: ServiceAgent.auth.request_getProfile,
      onStart: handleOpen,
      onEnd: handleClose,
      onSuccess: (resp) => {
        if (resp?.status == 200 && resp?.data?.statusCode == 200) {
          setUserInfo({ ...resp?.data?.data })
          setIsAuthLoading(false)
        }
      },
      onErrorMessage: 'دریافت اطلاعات کاربر با خطا مواجهه شد',
      onError: () => {
        setIsAuthLoading(false)
      },
    })
  }

  const logout = () => {
    removeItem(tokenKey)
    removeItem(userInfoLsKey)
    window.location.href = '/auth'
  }
  useEffect(() => {
    if (jwtToken) {
      setIsAuthLoading(true)
      getUserProfile()
    } else {
      setIsAuthLoading(false)
    }
  }, [jwtToken])

  const initialValues = {
    jwtToken,
    userInfo,
    saveUserInfo,
    saveToken,
    logout,
    setUserInfo,
    logInEstate,
    setLogInEstate,
    getUserProfile,
    isAuthLoading,  
  }

  return (
    <AuthContext.Provider value={initialValues}>
      {children}
    </AuthContext.Provider>
  )
}

export { AuthProvider, useAuth }
